(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/constants.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/constants.js');

const isServer = typeof exports === 'object';

const routes = {
  HOME: '/',
  TEAMS: '/minalag',
  TEAMS_CREATE: '/minalag/skapa',
  TEAMS_WAIT_FOR_BACKEND: '/minalag/vanta',
  TEAMS_INVITATION: '/inbjudan/:invitationId',
  HISTORY: '/historik',
  GAMEGUIDE: '/spelguide'
};

const depositType = {
  AFTER_PAY: 'afterpay',
  DIRECT: 'direct',
  INVITE: 'invite',
  CREATE: 'create'
};

const memberRoles = {
  TEAM_LEADER: 7,
  ADMIN: 6,
  NORMAL: 4
};

const contactInfoStatus = {
  VERIFIED: 2,
  NOTOFFEREDVERIFICATION: 4
};

const memberStates = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
};

const returnStatus = {
  SUCCESS: 'success',
  ERROR: 'error',
  CANCEL: 'cancel'
};

const localStorageDataType = {
  INVITE: 'invite',
  DEPOSIT: 'deposit'
};

const MAX_RETRIES_FOR_BACKEND = 5;

const MAX_MESSAGE_LENGTH = 300;

const MAX_MEMBERS = 20;

const exportedObjects = {
  routes,
  returnStatus,
  localStorageDataType,
  depositType,
  memberRoles,
  memberStates,
  contactInfoStatus,
  MAX_MESSAGE_LENGTH: MAX_MESSAGE_LENGTH,
  MAX_MEMBERS,
  MAX_RETRIES_FOR_BACKEND
};

if (isServer) {
  module.exports = exportedObjects;
} else {
  svs.arena.constants = exportedObjects;
}


 })(window);